import React from "react";

class GiftNoteUploader extends React.Component {
  constructor(props) {
    super();
    this.state = {
      resolution_acceptable: true,
      show_crop: true,
      preview_image_url: props.preview_image_url,
    };
    this.saveToDatabase = this.saveToDatabase.bind(this);
    this.saveSuccess = this.saveSuccess.bind(this);
    this.saveFail = this.saveFail.bind(this);
  }

  componentDidMount() {
    var myWidget = window.cloudinary.createUploadWidget(
      {
        cloudName: "framefox",
        uploadPreset: "framefox_gift_options",
        showPoweredBy: false,
        autoMinimize: false,
        showAdvancedOptions: false,
        maxFileSize: 200000000,
        resourceType: "image",
        cropping: true,
        croppingAspectRatio: 1.5,
        showSkipCropButton: false,
        folder: "gift-options",
        sources: [
          "local",
          "url",
          "camera",
          "google_drive",
          "dropbox",
          "instagram",
          "unsplash",
          "facebook",
        ],
        multiple: false,
        defaultSource: "local",
        styles: {
          palette: {
            window: "#FFFFFF",
            windowBorder: "#222",
            tabIcon: "#222",
            menuIcons: "#222",
            textDark: "#000000",
            textLight: "#FFFFFF",
            link: "#222",
            action: "#F8F6F0",
            inactiveTabIcon: "#4A3B33",
            error: "#F44235",
            inProgress: "#222",
            complete: "#222",
            sourceBg: "#FFFFFF",
          },
          fonts: {
            default: null,
            "'Figtree', sans-serif": {
              url: "https://fonts.googleapis.com/css?family=Figtree",
              active: true,
            },
          },
        },
      },
      (error, result) => {
        if (!error && result && result.event === "success") {
          this.saveToDatabase(result.info);
        } else if (!error && result && result.event === "close") {
          this.setState({ isLoading: false });
        }
      }
    );

    this.setState({ widget: myWidget });
  }

  saveToDatabase(data) {
    this.setState({ isSaving: true });

    const gift_option = {
      image: data.public_id,
    };

    $.ajax({
      method: "POST",
      url: this.props.post_image_url,
      data: {
        gift_option: gift_option,
      },
    })
      .done(this.saveSuccess)
      .fail(this.saveFail);
  }

  saveSuccess(data) {
    console.log(data);
    this.setState({ isSaving: false, preview_image_url: data.image_url });
    window.location.reload();
  }

  saveFail() {
    alert("Failed to save");
  }

  render() {
    return (
      <>
        {this.state.preview_image_url && (
          <img
            src={this.state.preview_image_url}
            className="img-fluid shadow my-3"
          />
        )}

        <button
          id="upload_widget"
          disabled={this.state.isLoading || this.state.isSaving}
          onClick={() => {
            this.setState({ isLoading: true });
            this.state.widget.open();
          }}
          className="btn btn-primary btn-lg disabled:bg-stone-400 disabled:border-stone-400 disabled:text-white disabled:cursor-not-allowed"
        >
          {this.state.isLoading || this.state.isSaving ? (
            <i className="fa-solid fa-spinner fa-spin mr-2"></i>
          ) : (
            <i className="fa-solid text-sm fa-arrow-up-from-bracket mr-2" />
          )}
          {this.state.isSaving ? "Storing" : "Upload a new design"}
        </button>
      </>
    );
  }
}

export default GiftNoteUploader;
